<template>
  <div class="content if-profile report-tab">
    <div class="md-layout ratios-report">
      <MRReportHeader :headerData="this.headerData" />

      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 marketprof-competitors p-0 mt-4">
        <div class="finanical-report-messages">
          <h1 class="section_header">Sales Classes</h1>
          <!-- <div class="">
            <md-dialog :md-active.sync="showDialog">
              <p>What is the employment structure in your industry market? <br> <br>
                  The Market Volume by Employment Class table displays the total market sales of industry sites in each bracket.
                  Projected sales of operations for which sales cannot be ascertained (Unknown ) are noted in the column and are
                  based on average industry site sales in the market area.
          </p>-->
          <!-- <p>The Establishments by Employment Class table displays the all market area industry operations.
                Projected employment of operations for which employment cannot be ascertained (Unknown) are based
                on average industry site employment in the market area.
          </p>-->
          <!-- </md-dialog>
            <md-card-header class="md-card-header-icon messages-box">
              <div class="card-icon md-ripple" @click="showDialog = true">
                <md-icon class="icon-arrow">double_arrow </md-icon>
                <md-icon>chat_bubble</md-icon>
              </div>
            </md-card-header>
          </div>-->
        </div>
        <div class="navbar md-toolbar md-transparent md-elevation-4 finanical-report-messages p-0">
          <nav-tabs-card no-label md-elevation="0">
            <template slot="content">
              <md-tabs md-alignment="left" class="if_card">
                <md-tab md-label="Sales" md-icon="area_chart" class="p-0">
                  <div class="md-layout">
                    <div class="md-layout-item md-size-100  blue-tbl p-0">
                      <md-card class="m-0">
                        <md-card-header>Sales</md-card-header>
                        <md-card-content>
                          <div class="md-layout p-4">
                            <div class="md-layout-item md-size-100">
                              <md-card class="md-card-profile">
                                <md-card-header class="md-card-header-icon">
                                  <h4 class="title m-0">
                                    <div class="md-layout-item md-medium-size-100 md-size-100 card-title p-0">Market
                                      Volume by Class ($million)</div>
                                  </h4>
                                  <!-- <h4 class="title text-left">Market Volume by Class ($million)</h4> -->
                                </md-card-header>
                                <md-card-content>
                                  <div class="md-layout">
                                    <div class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0">
                                      <md-table v-model="tableDataMarketVolume" table-header-color="blue"
                                        class="profit-and-loss-table">
                                        <md-table-row slot="md-table-row" slot-scope="{ item }">
                                          <md-table-cell class="md-table-side-label">{{ item.name }}</md-table-cell>
                                          <md-table-cell v-for="key in Object.keys(
                                            item.dates
                                          )" :key="key" :md-label="salesEmpCols[key]">{{ item.dates[key] }}
                                          </md-table-cell>
                                        </md-table-row>
                                      </md-table>
                                    </div>
                                  </div>
                                </md-card-content>
                              </md-card>
                              <md-card class="md-card-profile">
                                <md-card-header class="md-card-header-icon">
                                  <h4 class="title m-0">
                                    <div class="md-layout-item md-medium-size-100 md-size-100 card-title p-0">Percent
                                      Market Volume by Class</div>
                                  </h4>
                                  <!-- <h4 class="title text-left">Percent Market Volume by Class</h4> -->
                                </md-card-header>
                                <md-card-content>
                                  <div class="md-layout">
                                    <div class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0">
                                      <md-table v-model="
                                        tableDataPercentMarketVolumeClass
                                      " table-header-color="blue" class="profit-and-loss-table">
                                        <md-table-row slot="md-table-row" slot-scope="{ item }">
                                          <md-table-cell class="md-table-side-label">{{ item.name }}</md-table-cell>
                                          <md-table-cell v-for="key in Object.keys(
                                            item.dates
                                          )" :key="key" :md-label="salesEmpCols[key]">{{ item.dates[key] }}
                                          </md-table-cell>
                                        </md-table-row>
                                      </md-table>
                                    </div>
                                  </div>
                                </md-card-content>
                              </md-card>
                              <md-card class="md-card-profile">
                                <md-card-header class="md-card-header-icon">
                                  <h4 class="title m-0">
                                    <div class="md-layout-item md-medium-size-100 md-size-100 card-title p-0">Average
                                      Sales by Class (000)</div>
                                  </h4>
                                  <!-- <h4 class="title text-left">Average Sales by Class (000)</h4> -->
                                </md-card-header>
                                <md-card-content>
                                  <div class="md-layout">
                                    <div class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0">
                                      <md-table v-model="tableDataAverageSalesClass" table-header-color="blue"
                                        class="profit-and-loss-table">
                                        <md-table-row slot="md-table-row" slot-scope="{ item }">
                                          <md-table-cell class="md-table-side-label">{{ item.name }}</md-table-cell>
                                          <md-table-cell v-for="key in Object.keys(
                                            item.dates
                                          )" :key="key" :md-label="salesEmpCols[key]">{{ item.dates[key] }}
                                          </md-table-cell>
                                        </md-table-row>
                                      </md-table>
                                    </div>
                                  </div>
                                </md-card-content>
                              </md-card>

                            </div>
                            <md-card class="md-card-profile px-4">
                              <md-card-header>
                                <h4 class="title m-0">
                                  <div class="md-layout-item md-medium-size-100 md-size-100 card-title p-0">
                                    Competitive Market Narrative
                                  </div>
                                </h4>
                              </md-card-header>
                              <md-card-content>
                                <div class="md-layout">
                                  <div class="md-layout-item md-medium-size-100 md-size-100">
                                    <div class="extra_space">
                                      <!-- <h4 class="Performance Scores">
                                          Competitive Market Narrative
                                        </h4> -->
                                      <p>
                                        {{ cmnText.salesEmpClasses }}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </md-card-content>
                            </md-card>
                            <md-card class="md-card-profile px-4">
                              <md-card-header>
                                <h4 class="title m-0">
                                  <div class="md-layout-item md-medium-size-100 md-size-100 card-title p-0">
                                    <md-icon class="color-white">article</md-icon> Sales
                                  </div>
                                </h4>
                              </md-card-header>
                              <md-card-content>
                                <div class="md-layout">
                                  <div class="md-layout-item md-medium-size-100 md-size-100">
                                    <div class="extra_space">
                                      <!-- <h4 class="Performance Scores">
                                          Competitive Market Narrative
                                        </h4>-->
                                      <p>
                                        What is the employment structure in your industry market?<br><br>
                                        The Market Volume by Employment Class table displays the total market sales of
                                        industry sites in each bracket.
                                        Projected sales of operations for which sales cannot be ascertained (Unknown )
                                        are noted in the column and are based
                                        on average industry site sales in the market area.
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </md-card-content>
                            </md-card>
                          </div>
                        </md-card-content>
                      </md-card>
                    </div>
                  </div>
                </md-tab>
                <md-tab md-label="Employment" md-icon="assignment_ind" class="p-0">
                  <div class="md-layout">
                    <div class="md-layout-item md-size-100 p-0">
                      <md-card class="m-0">
                        <md-card-header>Employment</md-card-header>
                        <md-card-content>
                          <div class="md-layout p-4">
                            <div class="md-layout-item md-size-100">
                              <md-card class="md-card-profile">
                                <md-card-header class="md-card-header-icon">
                                  <h4 class="title m-0">
                                    <div class="md-layout-item md-medium-size-100 md-size-100 card-title p-0">
                                      Establishments</div>
                                  </h4>
                                  <!-- <h4 class="title text-left">Establishments</h4> -->
                                </md-card-header>
                                <md-card-content>
                                  <div class="md-layout">
                                    <div class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0">
                                      <md-table v-model="tableDataEstablishments" table-header-color="blue"
                                        class="profit-and-loss-table">
                                        <md-table-row slot="md-table-row" slot-scope="{ item }">
                                          <md-table-cell class="md-table-side-label">{{ item.name }}</md-table-cell>
                                          <md-table-cell v-for="key in Object.keys(
                                            item.dates
                                          )" :key="key" :md-label="salesEmpCols[key]">{{ item.dates[key] }}
                                          </md-table-cell>
                                        </md-table-row>
                                      </md-table>
                                    </div>
                                  </div>
                                </md-card-content>
                              </md-card>
                              <md-card class="md-card-profile">
                                <md-card-header class="md-card-header-icon">
                                  <h4 class="title m-0">
                                    <div class="md-layout-item md-medium-size-100 md-size-100 card-title p-0">Total
                                      Employment</div>
                                  </h4>
                                  <!-- <h4 class="title text-left">Total Employment</h4> -->
                                </md-card-header>
                                <md-card-content>
                                  <div class="md-layout">
                                    <div class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0">
                                      <md-table v-model="tableDataTotalEmployment" table-header-color="blue"
                                        class="profit-and-loss-table">
                                        <md-table-row slot="md-table-row" slot-scope="{ item }">
                                          <md-table-cell class="md-table-side-label">{{ item.name }}</md-table-cell>
                                          <md-table-cell v-for="key in Object.keys(
                                            item.dates
                                          )" :key="key" :md-label="salesEmpCols[key]">{{ item.dates[key] }}
                                          </md-table-cell>
                                        </md-table-row>
                                      </md-table>
                                    </div>
                                  </div>
                                </md-card-content>
                              </md-card>
                              <md-card class="md-card-profile">
                                <md-card-header class="md-card-header-icon">
                                  <h4 class="title m-0">
                                    <div class="md-layout-item md-medium-size-100 md-size-100 card-title p-0">Average
                                      Employment</div>
                                  </h4>
                                  <!-- <h4 class="title text-left">Average Employment</h4> -->
                                </md-card-header>
                                <md-card-content>
                                  <div class="md-layout">
                                    <div class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0">
                                      <md-table v-model="tableDataAverageEmployment" table-header-color="blue"
                                        class="profit-and-loss-table">
                                        <md-table-row slot="md-table-row" slot-scope="{ item }">
                                          <md-table-cell class="md-table-side-label">{{ item.name }}</md-table-cell>
                                          <md-table-cell v-for="key in Object.keys(
                                            item.dates
                                          )" :key="key" :md-label="salesEmpCols[key]">{{ item.dates[key] }}
                                          </md-table-cell>
                                        </md-table-row>
                                      </md-table>
                                    </div>
                                  </div>
                                </md-card-content>
                              </md-card>
                            </div>
                            <md-card class="md-card-profile px-4">
                              <md-card-header>
                                <h4 class="title m-0">
                                  <div class="md-layout-item md-medium-size-100 md-size-100 card-title p-0">
                                    <md-icon class="color-white">article</md-icon> Employment
                                  </div>
                                </h4>
                              </md-card-header>
                              <md-card-content>
                                <div class="md-layout">
                                  <div class="md-layout-item md-medium-size-100 md-size-100">
                                    <div class="extra_space">
                                      <!-- <h4 class="Performance Scores">
                                          Competitive Market Narrative
                                        </h4>-->
                                      <p>
                                        The Establishments by Employment Class table displays the all market
                                        area industry operations. Projected employment of operations for which
                                        employment cannot be ascertained (Unknown) are based on average industry
                                        site employment in the market area.
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </md-card-content>
                            </md-card>
                          </div>
                        </md-card-content>
                      </md-card>
                    </div>
                  </div>
                </md-tab>
              </md-tabs>
            </template>
          </nav-tabs-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { NavTabsCard } from '@/components';
import { mapState } from 'vuex';
import MRReportHeader from './_partials/MRReportHeader.vue';

export default {
  components: {
    NavTabsCard,
    MRReportHeader,
  },
  props: ['headerData'],
  data() {
    return {
      view: 'cash-flow-solvency',
      showDialog: false,
      tableDataMarketVolume: [],
      tableDataPercentMarketVolumeClass: [],
      tableDataAverageSalesClass: [],
      tableDataEstablishments: [],
      tableDataTotalEmployment: [],
      tableDataAverageEmployment: [],
    };
  },
  computed: {
    ...mapState({
      salesEmpSales: (state) =>
        state.user.market_report.data.data['salesEmpSales'],
      salesEmpCols: (state) => state.user.market_report.data['salesEmpCols'],
      salesEmpEmployment: (state) =>
        state.user.market_report.data.data['salesEmpEmployment'],
      cmnText: (state) => state.user.market_report.cmnText,
    }),
  },
  mounted() {
    let section = this.$route.query.section;

    if (!section) {
      section = 'cash-flow-solvency';
    }

    this.switchView(section);
    this.tableDataAverageSalesClass = Object.entries(
      this.salesEmpSales.avgSales
    ).map(([name, data]) => ({ name, dates: data }));
    this.tableDataMarketVolume = Object.entries(
      this.salesEmpSales.marketVolume
    ).map(([name, data]) => ({ name, dates: data }));
    this.tableDataPercentMarketVolumeClass = Object.entries(
      this.salesEmpSales.percentMarket
    ).map(([name, data]) => ({ name, dates: data }));

    this.tableDataAverageEmployment = Object.entries(
      this.salesEmpEmployment.average
    ).map(([name, data]) => ({ name, dates: data }));
    this.tableDataEstablishments = Object.entries(
      this.salesEmpEmployment.establishments
    ).map(([name, data]) => ({ name, dates: data }));
    this.tableDataTotalEmployment = Object.entries(
      this.salesEmpEmployment.total
    ).map(([name, data]) => ({ name, dates: data }));
  },
  watch: {
    '$route.query.section'() {
      let section = this.$route.query.section;

      if (!section) {
        section = 'cash-flow-solvency';
      }

      this.switchView(section);
    },
  },
  methods: {
    switchView: function (type) {
      this.view = type;
    },
  },
};
</script>
<style lang="scss">
.marketprof-competitors {
  .md-toolbar {
    .md-collapse {
      display: block;

      .md-collapse-content {
        p {
          padding-left: 20px;
        }
      }
    }
  }

  .competitors-list {
    .md-collapse-title {
      font-size: 12px;
      font-weight: 300;
      margin-left: 25px;
    }

    .md-icon {
      font-size: 12px;
      font-weight: 300;
      transform: rotate(-90deg);
      left: 0;
      color: rgba(0, 0, 0, 0.54);
    }
  }

  .competitors-map {
    iframe {
      height: 300px !important;
    }
  }
}

.if-profile .if_card .md-card-profile .md-card-content table tr td:last-child {
  color: #133a64;
}
</style>
